import SisDkpClienteTokenClient from '@/api/sis-dkp-cliente-token.client';
import { formatDateNotTime } from '@core/utils/filter';

const sisDkpClienteTokensService = new SisDkpClienteTokenClient();
export default {
  namespaced: true,
  state: () => ({
    dkp_cliente_token: {
      id: null,
      dkp_client_id: null,
      data_validade: null,
      updated_by: null,
      create_by: null,
    },
    codpy_dkp_cliente_token: null,
    dkp_clientes_tokens_all: [],
    filters: {
      page: 1,
      perPage: 10,
      sortBy: 'id',
      sortDesc: null,
      total: 0,
    },
    optionsClientes: [],
    isLoading: false,
  }),
  mutations: {
    SET_OPTIONS_CLIENTES(state, payload) {
      state.optionsClientes = JSON.parse(JSON.stringify(payload));
    },
    SET_DKP_CLIENTE_TOKEN(state, payload) {
      state.dkp_cliente_token = JSON.parse(JSON.stringify(payload));
      state.dkp_cliente_token.data_validade = formatDateNotTime(payload.data_validade);
    },
    SET_DKP_CLIENTES_TOKENS_ALL(state, payload) {
      state.codpy_dkp_cliente_token = JSON.parse(JSON.stringify(payload));
      state.dkp_clientes_tokens_all = JSON.parse(JSON.stringify(payload));
    },
    SET_FILTERS(state, payload) {
      state.filters = JSON.parse(JSON.stringify(payload));
    },
  },
  getters: {
    GET_FILTERS: (state) => state.filters,
    GET_DKPCLIENTES_TOKENS_ALL: (state) => state.dkp_clientes_tokens_all,
    GET_DKP_CLIENTE_TOKEN: (state) => state.dkp_cliente_token,
    GET_OPTIONS_CLIENTES: (state) => state.optionsClientes
      .map((cliente) => ({
        text: cliente.razao_social,
        value: cliente.id,
      })),
  },
  actions: {
    RESERT_DKP_CLIENTE_TOKEN({ commit }) {
      commit('SET_DKP_CLIENTE_TOKEN', {
        dkp_client_id: null,
        data_validade: null,
        updated_by: null,
        create_by: null,
        id: null,
      });
    },
    async findAll(ctx, queryParams, options) {
      const { data, ...paginations } = await sisDkpClienteTokensService.getDkpClientesTokens(queryParams);
      ctx.commit('SET_DKP_CLIENTES_TOKENS_ALL', data);
      ctx.commit('SET_FILTERS', {
        ...ctx.getters.GET_FILTERS,
        ...paginations,
      });
      return Promise.resolve({
        data,
        paginations,
      });
    },
  },
};
